module.exports = __webpack_public_path__ + "static/img/cor-rdznhsj.712a8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cor-rdznhsj.png
// module id = vd3C
// module chunks = 0